// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vI3d","select":"styles_select__23H2y"};